<div class="white-box main-black mt-4 p-4 border-radius">
	<div class="row mb-4">
		<div class="col">
			<h4>
				{{ title }}
			</h4>
		</div>
	</div>

	<!-- chart -->
	<div class="row" *ngIf="totalBatteriesCount; else noData">
		<sct-charts
			id="charge_ah"
			title="{{ title }}"
			[data]="distributionChartData"
			[columnNames]="chartColumns"
			[options]="chartConfig"
			[type]="'ColumnChart'"
			[height]="500"
		></sct-charts>
	</div>
</div>

<ng-template #noData class="mt-4">
	<div class="alert alert-info">{{'g.no_data_to_show' | translate}}</div>
</ng-template>
